var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504 504",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E07D46"
    },
    d: "M2,6v492h496V6H2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0B551"
    },
    d: "M137.2,310L137.2,310l-4.8,7.6c-10.8,17.6-2.8,32.4,18,32.4h199.2c20.8,0,28.8-14.8,18-32.4l-4.8-7.6 l0,0l0,0l-69.2-111.6l-4.8-8.4h-0.4h0.4l-19.2-31.2c-10.8-17.6-28.8-17.2-39.6,0.4l-19.2,31.2h0.4h-0.4L137.2,310L137.2,310z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500,504H4c-2.4,0-4-1.6-4-4V4c0-2.4,1.6-4,4-4h496c2.4,0,4,1.6,4,4v496C504,502.4,502.4,504,500,504z M8,496h488V8H8V496z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M440,448H68c-2.4,0-4-1.6-4-4V68c0-2.4,1.6-4,4-4h372c2.4,0,4,1.6,4,4v376C444,446.4,442.4,448,440,448z M72,440h364V72H72 V440z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2,70c-1.2,0-2.4-0.4-3.2-1.2l-42-48c-1.6-1.6-1.2-4,0.4-5.6c1.6-1.6,4-1.2,5.6,0.4l42,48c1.6,1.6,1.2,4-0.4,5.6 C68.8,69.6,68,70,67.2,70z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M485.2,482c-0.8,0-1.6-0.4-2.4-0.8l-46-36c-1.6-1.2-2-4-0.8-5.6s4-2,5.6-0.8l46,36c1.6,1.2,2,4,0.8,5.6 C487.6,481.6,486.4,482,485.2,482z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M438.8,70c-0.8,0-2-0.4-2.8-1.2c-1.6-1.6-1.6-4,0-5.6l46-48c1.6-1.6,4-1.6,5.6,0s1.6,4,0,5.6l-46,48 C441.2,69.6,440,70,438.8,70z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,482c-1.2,0-2.4-0.4-3.2-1.2c-1.6-1.6-1.2-4.4,0.4-5.6l42-36c1.6-1.6,4.4-1.2,5.6,0.4c1.6,1.6,1.2,4.4-0.4,5.6l-42,36 C26.8,482,26,482,24.8,482z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M434,200H302c-2.4,0-4-1.6-4-4s1.6-4,4-4h132c2.4,0,4,1.6,4,4S436.4,200,434,200z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206,200H74c-2.4,0-4-1.6-4-4s1.6-4,4-4h132c2.4,0,4,1.6,4,4S208.4,200,206,200z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M434,260h-96c-2.4,0-4-1.6-4-4s1.6-4,4-4h96c2.4,0,4,1.6,4,4S436.4,260,434,260z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170,260H74c-2.4,0-4-1.6-4-4s1.6-4,4-4h96c2.4,0,4,1.6,4,4S172.4,260,170,260z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M434,316h-64c-2.4,0-4-1.6-4-4s1.6-4,4-4h64c2.4,0,4,1.6,4,4S436.4,316,434,316z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138,316H74c-2.4,0-4-1.6-4-4s1.6-4,4-4h64c2.4,0,4,1.6,4,4S140.4,316,138,316z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M434,376H74c-2.4,0-4-1.6-4-4s1.6-4,4-4h360c2.4,0,4,1.6,4,4S436.4,376,434,376z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M434,140H74c-2.4,0-4-1.6-4-4s1.6-4,4-4h360c2.4,0,4,1.6,4,4S436.4,140,434,140z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M353.6,356H154.4c-10.8,0-19.2-4.4-24-12.4c-4.8-8.8-4-20,2.4-30L226,154.4c6.4-10.4,15.2-16,24.4-16l0,0 c8.4,0,16.4,5.2,22,14l102,161.2c6.4,10,7.2,21.2,2.4,30C373.2,351.6,364.4,356,353.6,356z M250.8,146L250.8,146 c-6.4,0-12.8,4.4-17.6,12.4L140,317.6c-4.8,7.6-5.6,16-2.4,22c3.2,5.6,9.2,8.4,16.8,8.4h199.2c8,0,13.6-3.2,16.8-8.4 c3.2-6,2.4-14.4-2.4-22L266,156.4l0,0C262,149.6,256.8,146,250.8,146z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M250,277.2c-2.4,0-4-1.6-4-4v-72c0-2.4,1.6-4,4-4s4,1.6,4,4v72C254,275.6,252.4,277.2,250,277.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M250,308c-1.2,0-2-0.4-2.8-1.2c-0.8-0.8-1.2-2-1.2-2.8c0-1.2,0.4-2,1.2-2.8c1.6-1.6,4-1.6,5.6,0c0.8,0.8,1.2,1.6,1.2,2.8 c0,1.2-0.4,2-1.2,2.8C252,307.6,251.2,308,250,308z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.0ff9ba7cb631747a13d163f86befc515.svg";
export { ForwardRef as ReactComponent };